import React from 'react';
import styled from 'styled-components';
import { Flex, Text } from '@cko/primitives';
import { IconActionChevronRight } from '@cko/icons';
import { SelectedMerchant } from '@cko/dashboard-shared';

import { TruncatedTextWithTooltip } from '../StyledHelperComponents';

interface AccountSelectorBreadCrumbProps {
  updatedView: SelectedMerchant | undefined;
}

const BreadCrumbContainer = styled(Flex)`
  padding: var(--layout-soybean) var(--layout-stamp);
  justify-content: space-between;
  align-items: center;
  gap: var(--layout-seed);
`;

const ViewLabel = styled(Text)`
  color: var(--base-text-secondary);
  font: var(--body-xs-medium);
`;

const BreadCrumbLabel = styled(TruncatedTextWithTooltip)`
  font: var(--body-xs-medium);
`;

const Chevron = styled(IconActionChevronRight)`
  fill: var(--base-icon-secondary);
`;

export const AccountSelectorBreadCrumb = ({ updatedView }: AccountSelectorBreadCrumbProps) => {
  const client = updatedView?.client?.name;
  const entity = updatedView?.entity?.name;
  const segment = updatedView?.segment?.name;

  let maxWidth = '320px';
  if (segment) {
    maxWidth = '196px';
  } else if (entity) {
    maxWidth = '150px';
  }
  return updatedView ? (
    <BreadCrumbContainer data-testid="account-selector-breadcrumb-container">
      <ViewLabel>View: </ViewLabel>
      <BreadCrumbLabel testId="account-selector-breadcrumb-client" maxWidth={maxWidth}>
        {client}
      </BreadCrumbLabel>
      {entity && (
        <>
          <Chevron />
          <BreadCrumbLabel testId="account-selector-breadcrumb-entity" maxWidth={maxWidth}>
            {entity}
          </BreadCrumbLabel>
        </>
      )}
      {segment && (
        <>
          <Chevron />
          <BreadCrumbLabel testId="account-selector-breadcrumb-segment" maxWidth={maxWidth}>
            {segment}
          </BreadCrumbLabel>
        </>
      )}
    </BreadCrumbContainer>
  ) : null;
};
